import React from 'react';
import styled, { keyframes } from 'styled-components';

const Wrapper = styled.div`
  display: inline-block;
  height: 30px;
`;

const loaderAnim = keyframes`
  0%, 40%, 100% {
    transform: scaleY(0.4);
  }  20% {
    transform: scaleY(1.0);
  }
`;

const Element = styled.div`
  background-color: var(--LoadingSpinner-color, ${({ theme }) => theme.common.colors.primary});
  height: 30px;
  width: 2px;
  margin: 0 1px;
  display: inline-block;
  animation: ${loaderAnim} 1.2s infinite ease-in-out;
`;

const Element1 = styled(Element)`
  animation-delay: -1.1s;
`;

const Element2 = styled(Element)`
  animation-delay: -1s;
`;

const Element3 = styled(Element)`
  animation-delay: -0.9s;
`;

const Element4 = styled(Element)`
  animation-delay: -0.8s;
`;

type LoadingSpinnerPropsType = {
  className?: string;
};
const LoadingSpinner = React.forwardRef<HTMLDivElement, LoadingSpinnerPropsType>(function LoadingSpinner(
  { className }: LoadingSpinnerPropsType,
  ref,
) {
  return (
    <Wrapper ref={ref} className={className}>
      <Element />
      <Element1 />
      <Element2 />
      <Element3 />
      <Element4 />
    </Wrapper>
  );
});

export default LoadingSpinner;
